import { useMemo } from 'react';
import { getMcpHttpUrl, getMcpIntlHttpUrl } from '@/app/common/api/config';
import { McpConnectSnippet } from '../components/McpConnectSnippet';
import { McpSessionsCard } from '../components/McpSessionsCard';

export default function ConnectPage() {
  const httpUrl = useMemo(() => getMcpHttpUrl(), []);
  const intlHttpUrl = useMemo(() => getMcpIntlHttpUrl(), []);

  return (
    <div className="mx-auto py-4" style={{ maxWidth: 720 }}>
      <McpConnectSnippet httpUrl={httpUrl} intlHttpUrl={intlHttpUrl} />
      <div className="mt-3">
        <McpSessionsCard />
      </div>
    </div>
  );
}
